export function shareDirectives(): string {
  return 'share-directives';
}
